export const LOGO_URL = "https://customer-assets.emergentagent.com/job_financial-tax-legal/artifacts/t1ar68a0_HSA_Logo1.png";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/services/financial", label: "Financial" },
  { to: "/services/tax", label: "Tax" },
  { to: "/services/insurance", label: "Insurance" },
  { to: "/services/legal", label: "Legal" },
  { to: "/services/business", label: "Business" },
  { to: "/about", label: "About" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export const SERVICE_OPTIONS = [
  "Financial Planning",
  "Tax Services",
  "Insurance Services",
  "Legal Service Coordination",
  "Business Services",
  "Immigration Support",
  "Estate Planning Support",
  "Not Sure / Need Guidance",
];

export const US_STATES = [
  "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware",
  "Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky",
  "Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi",
  "Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico",
  "New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania",
  "Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont",
  "Virginia","Washington","West Virginia","Wisconsin","Wyoming","District of Columbia",
];

export const CONTACT = {
  phone: "+1 (888) 555-0142",
  email: "info@hsaservicehub.com",
  address: "1100 Liberty Avenue, Suite 400, New York, NY 10001",
  hours: "Mon - Fri: 9:00 AM - 6:00 PM ET",
};

export const CALENDLY_URL = "https://calendly.com/hsaservicehub/30min";

export const BLOG_CATEGORIES = [
  "All",
  "Financial Planning",
  "Tax Tips",
  "Insurance Protection",
  "Estate Planning",
  "Business Services",
  "Family Protection",
];
